module.exports = __webpack_public_path__ + "img/sld_scb_7_green.5aae31fe.svg";